import { render, staticRenderFns } from "./Drawer.vue?vue&type=template&id=722351d4&scoped=true"
import script from "./Drawer.vue?vue&type=script&lang=js"
export * from "./Drawer.vue?vue&type=script&lang=js"
import style0 from "./Drawer.vue?vue&type=style&index=0&id=722351d4&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "722351d4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('722351d4')) {
      api.createRecord('722351d4', component.options)
    } else {
      api.reload('722351d4', component.options)
    }
    module.hot.accept("./Drawer.vue?vue&type=template&id=722351d4&scoped=true", function () {
      api.rerender('722351d4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/core/Drawer.vue"
export default component.exports